<template>
  <div class="manageclub">
    <h1>Manage your club</h1>
    <div v-if="me.isOwner">
      <b>Club name:</b> {{ club.name }}<br/>
      <b>Address 1:</b> {{ club.address1 }}<br/>
      <b>Address 2:</b> {{ club.address2 }}<br/>
      <b>City:</b> {{ club.city }}<br/>
      <b>Zipcode:</b> {{ club.zipcode}}<br/>
      <b>State:</b> {{ club.state }}<br/>
      <br/>
      <b>Owners:</b>
      <table class="table">
        <tr>
          <th>Coach</th>
          <th>Admin</th>
        </tr>
        <tr v-for="coach in coaches">
          <td>{{ coach.firstname }} {{ coach.lastname }}</td>
          <td><input type="checkbox"
                :checked="coach.isOwner ? 'checked' : false"
                :disabled="me.id == coach.id ? 'disabled' : false"
                v-on:change="changedInput"
                :value="coach.id"
                v-model="owners" />
          </td>
        </tr>
      </table>
      <br/>
    </div>
    <div v-else>
      Club management is for owners only. Talk to your club owner if you think this is in error.
    </div>
  </div>
</template>

<script>
  import config from "@/config"
  import alert from "@/components/Alert"

  export default {
    name : "manageclub",
    components : {
      alert
    },
    data(){
      return {
        me : {},
        club : {},
        coaches : [],
        owners : []
      }
    },
    beforeRouteEnter(to,from,next){
      next(vm => {
        vm.getData()
      })
    },
    beforeRouteUpdate(to,from,next){
      next(vm => {
        vm.getData()
      })
    },
    created(){
      this.getData()
    },
    methods : {
      getData(){
        console.log("getting data")
        return new Promise((resolve, reject) => {
          fetch(config.baseUrl+"user/me/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j => {
            fetch(config.baseUrl+"clubs/club/"+j.club.id, {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j2 => {
              fetch(config.baseUrl+"user/coaches/club/"+j.club.id, {
                credentials : "include"
              }).then(e => {
                return e.json()
              }).then(j3 => {
                this.setData(j, j2, j3)
                resolve()
              })
            })
          })
        })
      },
      setData(d,d2,d3){
        this.me = d
        this.club = d2
        this.coaches = d3
        this.coaches.forEach(coach => {
          if(coach.isOwner){
            let isThere = false
            this.owners.forEach(own => {
              if(own == coach.id) isThere = true
            })
            if(!isThere) this.owners.push(coach.id)
          }
        })
      },
      render(){},
      changedInput(e){
        console.log(this.coaches)
        let id = e.target.getAttribute("data-id")
        // update the database with the change
        fetch(config.baseUrl+"clubs/update/"+this.club.id, {
          credentials : "include",
          method : "PUT",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body : JSON.stringify({ owners : this.owners.join(",") })
        }).then(e => {
          return e.json()
        }).then(j => {
          // updated... probably nothing to do here
        })
      }
    }
  }
</script>

<style lang="scss">
  .manageclub {
    padding-right: 20px;
  }
</style>
